<template>
  <!--second tab-->
  <div>
    <div class="primary-panel--heading">
      <h3 class="h3">Signup</h3>
    </div>

    <!--fullname -->
    <div class="inputs-grid--full">
      <div
        data-input-module="primary-input"
        class="form-group primary-input primary-input---with-icon"
        v-bind:class="{ 'primary-input---with-error' : errors.has('fullname') }"
      >
        <input
          v-model="name"
          class="primary-input--field"
          id="fullname"
          name="fullname"
          value
          onkeyup="this.setAttribute('value', this.value);"
          onchange="this.setAttribute('value', this.value);"
          data-toggle="blur"
          v-validate="'required|min:3|max:60'"
          data-vv-as="Fullname"
        >
        <label class="primary-input--label" for="fullname">Fullname</label>
        <div class="primary-input--label-line-break"></div>
        <div class="primary-input--decoration"></div>
        <div class="primary-input--icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            class
          >
            <path
              d="M0 9a9 9 0 1 0 17.98.02A9 9 0 0 0 0 9zm1.8 0a7.2 7.2 0 1 1 14.4 0A7.2 7.2 0 0 1 1.8 9zM11 7a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm-2 3c1.33 0 4 .67 4 2v1H5v-1c0-1.33 2.67-2 4-2z"
            ></path>
          </svg>
        </div>
        <div v-show="errors.has('fullname')" class="primary-input--error">
          <div class="primary-input--error-text">Please enter your first name and last name</div>
          <div class="primary-input--error-icon"></div>
        </div>
      </div>
    </div>
    <!--./fullname -->
    <!--email -->
    <div class="inputs-grid--full">
      <div
        data-input-module="primary-input"
        class="form-group primary-input primary-input---with-icon"
        v-bind:class="{ 'primary-input---with-error' : errors.has('email') }"
      >
        <input
          v-model="email"
          class="primary-input--field"
          id="email"
          value
          onkeyup="this.setAttribute('value', this.value);"
          onchange="this.setAttribute('value', this.value);"
          data-toggle="blur"
          v-validate="'required|email'"
          name="email"
          data-vv-as="Email"
        >
        <label class="primary-input--label" for="email">Enter email</label>
        <div class="primary-input--label-line-break"></div>
        <div class="primary-input--decoration"></div>
        <div class="primary-input--icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <path
              transform="translate(-731 -21)"
              d="M739.99 21a9 9 0 1 1 .01 18 9 9 0 0 1-.01-18zm.01 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm3.2-10.2c.44 0 .8.34.8.75v4.5c0 .41-.36.75-.8.75h-6.4c-.44 0-.8-.34-.8-.75v-4.5c0-.41.36-.75.8-.75zm0 1.5v-.75l-3.2 1.88-3.2-1.88v.75l3.2 1.88z"
            ></path>
          </svg>
        </div>
        <div v-show="errors.has('email')" class="primary-input--error">
          <div class="primary-input--error-text">Please enter valid email address</div>
          <div class="primary-input--error-icon"></div>
        </div>
      </div>
    </div>
    <!--./email -->
    <!--password -->
    <div class="inputs-grid--full">
      <div
        data-input-module="primary-input"
        class="form-group primary-input primary-input---with-icon"
        v-bind:class="{ 'primary-input---with-error' : errors.has('passwordas') }"
      >
        <input
          v-model="password"
          class="primary-input--field"
          id="passwordIs"
          name="passwordas"
          ref="passwordas"
          type="password"
          value
          onkeyup="this.setAttribute('value', this.value);"
          onchange="this.setAttribute('value', this.value);"
          data-toggle="blur"
          v-validate="'required|min:6|max:20'"
          data-vv-as="Password"
        >
        <label class="primary-input--label" for="passwordIs">Enter password</label>
        <div class="primary-input--label-line-break"></div>
        <div class="primary-input--decoration"></div>
        <div class="primary-input--suffix">
          <div class="primary-input--password-eye" onclick="window.showPassword(this)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="11"
              height="7"
              viewBox="0 0 11 7"
              class
            >
              <path
                transform="translate(-1190 -502)"
                d="M1201 505.5a6.15 6.15 0 0 1-5.5 3.5 6.15 6.15 0 0 1-5.5-3.5 6.15 6.15 0 0 1 5.5-3.5c2.4 0 4.48 1.42 5.5 3.5zm-2.92-1.72a2.78 2.78 0 0 1-2.58 3.76 2.78 2.78 0 0 1-2.58-3.76 5.02 5.02 0 0 0-1.74 1.72c.41.66.96 1.22 1.6 1.64a4.97 4.97 0 0 0 5.43 0c.65-.42 1.2-.98 1.6-1.64a5.28 5.28 0 0 0-1.73-1.72zm-3.61-.45c-.57 0-1.03.47-1.03 1.05 0 .58.46 1.05 1.03 1.05.57 0 1.03-.47 1.03-1.05 0-.58-.46-1.05-1.03-1.05z"
              ></path>
            </svg>
          </div>
        </div>
          <div v-show="errors.has('passwordas')" class="primary-input--error">
            <div class="primary-input--error-text">Please enter password</div>
            <div class="primary-input--error-icon"></div>
          </div>
        <div class="primary-input--icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            class
          >
            <path
              transform="translate(-130 -333)"
              d="M139 333a9 9 0 1 1 0 18.01 9 9 0 0 1 0-18.01zm0 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm2.25-8.53c.41 0 .75.34.75.76v3.8c0 .43-.34.77-.75.77h-4.5a.76.76 0 0 1-.75-.76v-3.81c0-.42.34-.76.75-.76h.38v-.77c0-1.05.84-1.9 1.87-1.9a1.9 1.9 0 0 1 1.88 1.9v.77zm-3.41-.77v.77h2.32v-.77c0-.65-.52-1.18-1.16-1.18-.64 0-1.16.53-1.16 1.18z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <!--./password -->
    <!--repeat password -->
    <div class="inputs-grid--full">
      <div
        data-input-module="primary-input"
        class="form-group primary-input primary-input---with-icon"
        v-bind:class="{ 'primary-input---with-error' : errors.has('passwordRep') }"
      >
        <input
          v-model="passwordRepeat"
          class="primary-input--field"
          id="passwordRa"
          name="passwordRep"
          type="password"
          value
          onkeyup="this.setAttribute('value', this.value);"
          onchange="this.setAttribute('value', this.value);"
          data-toggle="blur"
          v-validate="'required|confirmed:passwordas'" 
        >
        <label class="primary-input--label" for="passwordRa">Repeat password</label>
        <div class="primary-input--label-line-break"></div>
        <div class="primary-input--decoration"></div>
        <div class="primary-input--suffix">
          <div class="primary-input--password-eye" onclick="window.showPassword(this)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="11"
              height="7"
              viewBox="0 0 11 7"
            >
              <path
                transform="translate(-1190 -502)"
                d="M1201 505.5a6.15 6.15 0 0 1-5.5 3.5 6.15 6.15 0 0 1-5.5-3.5 6.15 6.15 0 0 1 5.5-3.5c2.4 0 4.48 1.42 5.5 3.5zm-2.92-1.72a2.78 2.78 0 0 1-2.58 3.76 2.78 2.78 0 0 1-2.58-3.76 5.02 5.02 0 0 0-1.74 1.72c.41.66.96 1.22 1.6 1.64a4.97 4.97 0 0 0 5.43 0c.65-.42 1.2-.98 1.6-1.64a5.28 5.28 0 0 0-1.73-1.72zm-3.61-.45c-.57 0-1.03.47-1.03 1.05 0 .58.46 1.05 1.03 1.05.57 0 1.03-.47 1.03-1.05 0-.58-.46-1.05-1.03-1.05z"
              ></path>
            </svg>
          </div>
        </div>
        <div v-show="errors.has('passwordRep')" class="primary-input--error">
            <div class="primary-input--error-text">Passwords must match</div>
            <div class="primary-input--error-icon"></div>
          </div>
        <div class="primary-input--icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <path
              transform="translate(-130 -333)"
              d="M139 333a9 9 0 1 1 0 18.01 9 9 0 0 1 0-18.01zm0 16.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4zm2.25-8.53c.41 0 .75.34.75.76v3.8c0 .43-.34.77-.75.77h-4.5a.76.76 0 0 1-.75-.76v-3.81c0-.42.34-.76.75-.76h.38v-.77c0-1.05.84-1.9 1.87-1.9a1.9 1.9 0 0 1 1.88 1.9v.77zm-3.41-.77v.77h2.32v-.77c0-.65-.52-1.18-1.16-1.18-.64 0-1.16.53-1.16 1.18z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <!--./repeat password -->
    <div class="modal-terms-agreement">
      <div data-input-module="checkbox-input" class="form-group checkbox-input">
        <input class="checkbox-input--field" type="checkbox" id="id12" value="1" name="id12" v-validate="'required'">
        <label class="checkbox-input--label" for="id12">
          <span class="checkbox-input--checkbox">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10">
              <path
                d="M5.19 9.91a.93.93 0 0 1-.61-.23L.25 5.69a.76.76 0 0 1 0-1.12.9.9 0 0 1 1.21 0l3.73 3.44 7.35-6.78a.9.9 0 0 1 1.21 0c.33.32.33.81 0 1.12L5.79 9.68a.88.88 0 0 1-.6.23z"
              ></path>
            </svg>
          </span>
          <span>
            I agree with
            <a href="/p/pages/terms-of-use" target="_blank">Terms of use</a>
          </span>
        </label>
      </div>
    </div>
    <div v-show="errors.has('id12')" class="primary-input--error">
            <div class="primary-input--error-text">You must agree with terms of use</div>
            <div class="primary-input--error-icon"></div>
          </div>

    <div>
      <label style="color:red" v-if="hasError">User exist or server problems. Try later</label>
    </div>
    <div class="text-center mb-3">
      <button v-on:click="register" type="button" class="btn btn-primary block">Sign up</button>
    </div>

    <div>
      <label class="text-center modal-text">
        <a href="#" id="signin">Already have an account?</a>
      </label>
    </div>
  </div>
  <!--/. second tab -->
</template>
<script>
import * as api from "../modules/api.js";
import { mapState } from "vuex";

var me;
export default {
  name: "sign-up",
  data() {
    return {
      name: "",
      email: "",
      password: "",
      passwordRepeat: "",
      temsAccepted: 0
    };
  },
  methods: {
    loginWindow: function() {
      this.$store.dispatch("loginWindow");
    },
    register: function() {
      this.$validator.validate().then(result => {
        if (result) {
          this.$store.dispatch("register", {
            name: this.name,
            email: this.email,
            password: this.password,
            passwordRepeat: this.passwordRepeat
          });
        }
      });
    }
  },
  computed: {
    ...mapState({
      hasError: state => state.user.signupHasError,
      signupSuccess: state => state.user.signupSuccess
    })
  },
};
</script>